import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { StorageService } from '@core/services/storage.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-image',
  templateUrl: './custom-image.component.html',
  styleUrls: ['./custom-image.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class CustomImageComponent implements OnChanges, OnDestroy {
  readonly unsubscribe$ = new Subject();
  @Input() imgId = '';
  @Input() src = '';
  @Input({ required: true }) alt = '';
  @Input() defaultImage = '/assets/images/default/avatar.webp';

  @Input() styleClass = '';
  @Input() imageClass = '';
  @Input() styles: { [key: string]: string };
  @Input() imageStyles: { [key: string]: string };

  @Output() error = new EventEmitter();

  imageLoaded = false;
  imageUrl: SafeUrl = '';

  constructor(public storageService: StorageService) {}

  ngOnChanges() {
    if (this.imgId) {
      this.imageUrl = this.storageService.getFileUrl(this.imgId);
    } else if (this.src) {
      this.imageUrl = this.src;
    }
  }

  onError() {
    this.imageLoaded = true;
    this.imageUrl = this.defaultImage;

    this.error.emit();
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
